import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { BACKEND_URL } from "../lib/api";

const DEFAULTS = {
  app_name: "SalonFlow",
  logo_url: "",
  primary_color: "#F43F5E",
  accent_color: "#FB923C",
  sidebar_bg: "#FFFFFF",
  sidebar_text: "#64748B",
  sidebar_active_bg: "#FFF1F2",
  sidebar_active_text: "#E11D48",
};

const BrandingContext = createContext(DEFAULTS);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const loadBranding = useCallback(async () => {
    try {
      const res = await api.get("/settings/branding");
      setBranding({ ...DEFAULTS, ...res.data });
    } catch {
      setBranding(DEFAULTS);
    }
  }, []);

  useEffect(() => { loadBranding(); }, [loadBranding]);

  const updateBranding = useCallback(async (newValues) => {
    try {
      const res = await api.put("/settings/branding", newValues);
      setBranding({ ...DEFAULTS, ...res.data });
      return true;
    } catch {
      return false;
    }
  }, []);

  const getLogoSrc = useCallback(() => {
    if (!branding.logo_url) return null;
    if (branding.logo_url.startsWith("http")) return branding.logo_url;
    return `${BACKEND_URL}${branding.logo_url}`;
  }, [branding.logo_url]);

  return (
    <BrandingContext.Provider value={{ ...branding, updateBranding, loadBranding, getLogoSrc }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
